module.exports = __webpack_public_path__ + "img/avalanche-avax-logo.bcfbb162.png";